import { createApi } from "@reduxjs/toolkit/query/react";
import { APIBaseQuery } from "../axiosBase";

export const mentorApi = createApi({
  reducerPath: "mentorApi",
  baseQuery: APIBaseQuery,
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    becomeMentor: builder.mutation({
      query(data) {
        return {
          url: "mentor/becomeMentor",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    acceptRequest: builder.mutation({
      query(data) {
        return {
          url: "mentor/mentorship/acceptRequest",
          method: "PUT",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    rejectRequest: builder.mutation({
      query(data) {
        return {
          url: "mentor/mentorship/rejectRequest",
          method: "PUT",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    addReview: builder.mutation({
      query(data) {
        return {
          url: "mentor/review",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    sendMentorshipRequest: builder.mutation({
      query(data) {
        return {
          url: "mentor/mentorship/request",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    getMentorshipRequests: builder.query({
      query(filter) {
        const { id } = filter;

        return {
          url: `mentor/mentorship/request`,
          params: { id },
        };
      },
      keepUnusedDataFor: 1,
    }),
    addMeeting: builder.mutation({
      query(data) {
        return {
          url: "mentor/meeting",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    addMeetingConclusion: builder.mutation({
      query(data) {
        return {
          url: "mentor/meeting/conclusion",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    addMeetingComment: builder.mutation({
      query(data) {
        return {
          url: "mentor/meeting/comment",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    updateMeetingComment: builder.mutation({
      query(data) {
        return {
          url: "mentor/meeting/comment",
          method: "PUT",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    deleteMeetingComment: builder.mutation({
      query({ commentId, meetingId }) {
        return {
          url: `mentor/meeting/comment`,
          method: "DELETE",
          data: { commentId, meetingId },
        };
      },
      invalidatesTags: ["Mentor"],
    }),
      deleteMentor: builder.mutation({
      query({ mentorId }) {
        return {
          url: `mentor`,
          method: "DELETE",
          data: { mentorId },
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    getAllMentors: builder.query({
      query(filter) {
        const { skip, take, sortField, orderBy, text ,skillText} = filter;
        return {
          url: `mentor/filter`,
          params: {
            skip,
            take,
            sortField,
            orderBy,
            text,
            skillText
          },
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["Mentor"],
      transformResponse: (result) => result?.data,
    }),
    getMeetingComments: builder.query({
      query(filter) {
        const {
          text,
          meetingId,
          meetingCommentId,
          skip,
          take,
          sortField,
          orderBy,
        } = filter;
        return {
          url: `mentor/meeting/commentFilter`,
          params: {
            text,
            meetingId,
            meetingCommentId,
            skip,
            take,
            sortField,
            orderBy,
          },
        };
      },
      providesTags: ["Mentor"],
      keepUnusedDataFor: 1,
      transformResponse: (result) => result?.data,
    }),
    getSuggestedMentors: builder.query({
      query() {
        return {
          url: `mentor/suggestedMentors`,
        };
      },
      providesTags: ["Mentor"],
      keepUnusedDataFor: 1,
      transformResponse: (result) => result,
    }),
    getMentorById: builder.query({
      query(filter) {
        const { id } = filter;
        return {
          url: `mentor/byId`,
          method: "GET",
          params: { id: id },
        };
      },
      transformResponse: (result) => result,
      providesTags: ["Mentor"],
    }),
    getMentorshipById: builder.query({
      query(filter) {
        const { id } = filter;
        return {
          url: `mentor/mentorship/byId`,
          method: "GET",
          params: { id: id },
        };
      },
      transformResponse: (result) => result,
      providesTags: ["Mentor"],
    }),
    getMeetingById: builder.query({
      query(filter) {
        const { id } = filter;
        return {
          url: `mentor/meeting/byId`,
          method: "GET",
          params: { id: id },
        };
      },
      transformResponse: (result) => result,
      providesTags: ["Mentor"],
    }),
     downloadMentorFile: builder.query({
      query(filter) {
        const { fileId } = filter;
        return {
          url: `mentor/meeting/downloadFile`,
          method: "GET",
          params: { fileId: fileId },
        };
      },
      transformResponse: (result) => result,
      providesTags: ["Mentor"],
    }),
    getMentorshipMentor: builder.query({
      query(filter) {
        const { id } = filter;
        return {
          url: `mentor/mentorship/forMentor`,
          method: "GET",
          params: { id: id },
        };
      },
      transformResponse: (result) => result,
      providesTags: ["Mentor"],
    }),
    getMentorshipMentee: builder.query({
      query(filter) {
        const { id } = filter;
        return {
          url: `mentor/mentorship/forMentee`,
          method: "GET",
          params: { id: id },
        };
      },
      transformResponse: (result) => result,
      providesTags: ["Mentor"],
    }),
    sendFinalisationRequest: builder.mutation({
      query(data) {
        return {
          url: "mentor/mentorship/requestFinalisation",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    acceptFinalisationRequest: builder.mutation({
      query(data) {
        return {
          url: "mentor/mentorship/acceptRequestFinalisation",
          method: "POST",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    updateMentorSkills: builder.mutation({
      query(data) {
        return {
          url: "mentor/skills",
          method: "PUT",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    updateMentorStatus: builder.mutation({
      query(data) {
        return {
          url: "mentor/status",
          method: "PUT",
          data,
        };
      },
      invalidatesTags: ["Mentor"],
    }),
    addFileToMeet: builder.mutation({
      query(form) {
        return {
          url: "mentor/meeting/file",
          method: "POST",
          data: form,
        };
      },
      transformResponse: (result) => result,
      invalidatesTags: ["Mentor"],
    }),
    updateConclusion: builder.mutation({
      query(form) {
        return {
          url: "mentor/meeting/conclusion",
          method: "PUT",
          data: form,
        };
      },
      transformResponse: (result) => result,
      invalidatesTags: ["Mentor"],
    }),
  }),                      
});

export const {
  useAcceptFinalisationRequestMutation,
  useRejectRequestMutation,
  useLazyDownloadMentorFileQuery,
  useGetMeetingByIdQuery,
  useUpdateConclusionMutation,
  useAddFileToMeetMutation,
  useDeleteMentorMutation,
  useGetSuggestedMentorsQuery,
  useUpdateMentorSkillsMutation,
  useUpdateMentorStatusMutation,
  useSendFinalisationRequestMutation,
  useGetMentorshipByIdQuery,
  useGetMeetingCommentsQuery,
  useAddMeetingCommentMutation,
  useUpdateMeetingCommentMutation,
  useDeleteMeetingCommentMutation,
  useAcceptRequestMutation,
  MentorejectRequestMutation,
  useAddMeetingConclusionMutation,
  useAddMeetingMutation,
  useGetMentorshipRequestsQuery,
  useGetMentorshipMenteeQuery,
  useGetMentorshipMentorQuery,
  useSendMentorshipRequestMutation,
  useBecomeMentorMutation,
  useLazyGetAllMentorsQuery,
  useLazyGetMentorByIdQuery,
} = mentorApi;
